<template>
  <div class="page">
    <v-foxconn v-if='isFoxconn' titleText='首次充值满5元,送5元' />
    <v-cells paddingBottom="8pt" paddingTop="5pt" paddingLeft="16pt"  paddingRight="16pt">
      <v-item-cell leftText="账户余额"  :rightText="formatPrice(balance,user.companyId)"/>
      <!-- <v-item-cell leftText="选择支付方式" leftColor="black"/>
      <div v-for="(payment, index) in rechargeSupports">
        <v-radio v-if="payment.payType === 'alipay'" name='alipay' v-model="selectedPayType" nameString="支付宝">
          <i class="icon ali icon-size" slot='icon'>
            &#xe626;
          </i>
        </v-radio>
        <v-radio v-if="payment.payType === 'weixinpay'" name='weixinpay' v-model="selectedPayType" nameString="微信">
          <i class="icon weixin icon-size" slot='icon'>
            &#xe600;
          </i>
        </v-radio>
      </div>
      <v-input class="button" v-model="showValue" hint="输入充值金额" type="number"/>
      <div class="tip-color"> {{ balanceTip }} </div> -->
    </v-cells>
    <!-- <v-button  text='确定充值' primary  @click="dialog.open=true" class="button btn-area"></v-button> -->
    <v-dialog :open="dialog.open" @close='dialog.open=false' :okText="dialog.okText" :cancelText="dialog.cancelText" @cancal="dialog.open=false" @ok="commit" :content="dialogContent">
    </v-dialog>
  </div>
</template>
<script>
  import mixin from '../mixin'
  import { mapState } from 'vuex'
  import api from '../../api'
  import ap from './ap'
  export default {
    mixins: [mixin],
    created () {
      this.setTitle('充值')
      this.getBalance()
    },
    data () {
      return {
        balance: '-',
        selectedPayType: '',
        cashDepositBalance: 0,
        balanceTip: '',
        rechargeSupports: [],
        rechargeSupportDic: {},
        showValue: '0',
        tipMessage: '🙄',
        dialog: {
          open: false,
          okText: '去充值',
          cancelText: '再想想'
        },
        ap: ap
      }
    },
    computed: {
      ...mapState({ user: state => state.user, banners: state => state.homepage.banners }),
      rechargeValue () {
        return parseFloat(this.showValue) * 100
      },
      dialogContent () {
        let info = !this.user.employeeNo ? `手机号：${this.user.phoneNumber}` : `工号：${this.user.employeeNo}`
        return `向${this.user.userName}(${info})账户充值${this.showValue}元`
      },
      isFoxconn () {
        return this.user.companyId.toString() === '24' && this.formatDate(Date.now()) === '2017-11-09'
      }
    },
    watch: {
      selectedPayType () {
        this.rechargeSupports.forEach(item => {
          if (item.payType === this.selectedPayType) {
            this.rechargeSupportDic = item
          }
        })
      }
    },
    methods: {
      getBalance () {
        api.getBalance(this.user).then((data) => {
          this.balance = data.totalBalance
          this.rechargeSupports = data.rechargeSupports
          this.selectedPayType = this.rechargeSupports[0].payType
          this.rechargeSupportDic = this.rechargeSupports[0]
          // if (data.subsidyBalance && data.cashDepositBalance) {
          // this.balanceTip = `账户余额: 包含餐补${this.formatPrice(data.subsidyBalance ? data.subsidyBalance : 0)},现金${this.formatPrice(data.cashDepositBalance ? data.cashDepositBalance : 0)},赠送${this.formatPrice(data.bonusPriorityBalance ? data.bonusPriorityBalance : 0)}`
          this.balanceTip = `账户余额: 包含餐补${this.formatPrice(data.subsidyBalance ? data.subsidyBalance : 0)}, 赠送${this.formatPrice(data.bonusPriorityBalance ? data.bonusPriorityBalance : 0)}`
          // }
        }, (data) => {
        })
      },
      commit () {
      // 充值金额要大于0
        if (this.rechargeValue === 0 || this.rechargeValue === undefined) {
          this.tipMessage = '充值金额不能为0'
          this.showToast(this.tipMessage)
          return
        }
        // 充值金额不能低于 最低限制金额
        if (this.rechargeValue < this.rechargeSupportDic.minAllowedValue) {
          if (this.rechargeSupportDic.minAllowedValue > 0) {
            this.tipMessage = `最低充值金额不能低于${this.formatPrice(this.rechargeSupportDic.minAllowedValue)}`
            this.showToast(this.tipMessage)
            return
          }
        }
        // 充值金额 要小于 允许充值的最高金额
        if (this.rechargeValue > this.maxAllowedValue) {
          if (this.maxAllowedValue > 0) {
            this.tipMessage = `最高允许充值${this.formatPrice(this.rechargeSupportDic.maxAllowedValue)}`
            this.showToast(this.tipMessage)
            return
          }
        }
        //  当前余额大于 餐补 + 现金的最高金额 不能充值
        if (this.balance > this.rechargeSupportDic.accountMaxAllowed || this.balance + this.rechargeValue > this.rechargeSupportDic.accountMaxAllowed) {
          if (this.rechargeSupportDic.accountMaxAllowed > 0) {
            this.tipMessage = `您充值后账户的金额超过上限${this.formatPrice(this.rechargeSupportDic.accountMaxAllowed)}`
            this.showToast(this.tipMessage)
            return
          }
        }
        // 现金
        if (this.cashDepositBalance > this.rechargeSupportDic.accountCashMaxAllowed || this.cashDepositBalance + this.rechargeValue > this.rechargeSupportDic.accountCashMaxAllowed) {
          if (this.rechargeSupportDic.accountCashMaxAllowed > 0) {
            this.tipMessage = `账户的现金金额不能超过${this.formatPrice(this.rechargeSupportDic.accountCashMaxAllowed)}`
            this.showToast(this.tipMessage)
            return
          }
        }
        this.recharge()
      },
      recharge () {
        this.showLoading()
        api.recharge(this.user, this.selectedPayType, this.rechargeValue).then((data) => {
          api.getPayInfo(this.user, data['orderId'], this.selectedPayType).then((data) => {
            this.hideLoading()
            if (data.type === 'alipay') {
              window._AP.pay(data.aliPayString)
            } else if (data.type === 'weixinpay') {
              window.wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: data.wxPayingForm.weConfig.wxId, // 必填，公众号的唯一标识
                timestamp: data.wxPayingForm.weConfig.timestamp, // 必填，生成签名的时间戳
                nonceStr: data.wxPayingForm.weConfig.nonceStr, // 必填，生成签名的随机串
                signature: data.wxPayingForm.weConfig.signature, // 必填，签名，见附录1
                jsApiList: ['jsApiList'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              wx.ready(() => {
                wx.chooseWXPay({
                  timestamp: data.wxPayingForm.weData.weixinpay.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: data.wxPayingForm.weData.weixinpay.nonceStr, // 支付签名随机串，不长于 32 位
                  package: data.wxPayingForm.weData.weixinpay.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                  signType: data.wxPayingForm.weData.weixinpay.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                  paySign: data.wxPayingForm.weData.weixinpay.paySign, // 支付签名
                  success: (res) => {
                    this.setTempParam({payType: this.selectedPayType, price: this.rechargeValue})
                    $router.push({
                      path: '/pay-success'
                    })
                  },
                  fail: function (res) {
                    this.showToast(res)
                  },
                  cancel: function (res) {
                    this.showToast(res)
                  }
                })
              })
            }
          }, (data) => {
            this.hideLoading()
            this.showToast(data)
          })
        }, (data) => {
          this.showToast(data)
          this.hideLoading()
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
@import '../../css/var'
$tab-height = pt(100)
.page
  min-height 100vh
  height 100%
  background #F3F3F3
.ali
  color #03A0E8
.weixin
  color #30C37E
.icon-size
  font-size pt(70)
.btn-area
  margin-top pt(40)
  margin-left 16px
  margin-right 16px
.tip-color
  color #888888
.foxconn
  margin-left 16pt
  margin-right 16pt

</style>



// WEBPACK FOOTER //
// recharge.vue?08dffc00